import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { trans } from '../../../localization/language';
import * as realinfoActions from '../../../actions/realinfo';
import { encryptPassword, validateDate, validateIdcard } from '../../../utils';
import { MINMINAL_ID_CARD_LENGTH,
	BIRTHDAY_REGEX,
	SAMPLE_BIRTHDAY,
	BIRTHDAY_STR_LENGTH,
	COUNTRY_NEED_REAL_INFO_BIRTHDAY
} from '../../../constants';
import ErrorMsg from '../../common_components/ErrorMsg';
import Agreement from '../../Agreement';

class SaveRealinfo extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			realnameError: null,
			idcardError: null,
			passwordError: null,
			realName: '',
			idcard: '',
			password: ''
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.realinfo.status == 5) {
			this.setState({passwordError: trans('error_verify_password')});
		}
	}

	handleSubmit(event) {
		event.preventDefault();
		if (this.validateInputs()) {
			var encryptedPassword = encryptPassword(this.state.password);
			this.props.saveRealinfo(this.state.realName, this.state.idcard, this.state.birthday, encryptedPassword);
		}
	}

	handleChangeName(event) {
		this.setState({realName: event.target.value});
	}

	handleChangeIdcard(event) {
		this.setState({idcard: event.target.value});
	}

	handleChangeBirthday(event) {
		var test_birthday = event.target.value + SAMPLE_BIRTHDAY.substr(event.target.value.length);
		if(BIRTHDAY_REGEX.test(test_birthday)){
			this.setState({birthday: event.target.value});
			this.setState({birthdayError: null});
		}else{
			this.setState({birthday: null});
			this.setState({birthdayError: trans('error_date_format')});
		}

	}

	handleChangeCurrentPassword(event) {
		this.setState({password: event.target.value});
	}

	validate_realname(realname) {
		if(!realname) {
			this.setState({realnameError: trans('error_realname')});
			return false;
		}
		return true
	}

	validate_idcard(idcard) {
		if (!idcard) {
			this.setState({idcardError: trans('error_idcard')});
			return false;
		}else if(idcard.length < MINMINAL_ID_CARD_LENGTH){
			this.setState({idcardError: trans('id_card_min_error')});
			return false;
		}else if(!validateIdcard(idcard)) {
			this.setState({idcardError: trans('error_invalid_idcard')});
			return false;
		}
		return true;
	}
	
	validate_birthday(birthday) {
		if(!this.props.need_birthday) return true;
		if(!birthday || birthday.length != BIRTHDAY_STR_LENGTH) {
			this.setState({birthdayError: trans('error_date_format')});
			return false;
		}else {
			if(!validateDate(birthday)) {
				this.setState({birthdayError: trans('error_invalid_date')});
				return false;
			}
		}
		return true;
	}
	
	validate_password(password) {
		if (!password) {
			this.setState({passwordError: trans('error_verify_password')});
			return false;
		}
		return true;
	}

	validateInputs() {
		this.setState({
			realnameError: null,
			idcardError: null,
			birthdayError: null,
			passwordError: null
		});
		return this.validate_realname(this.state.realName)
			&&this.validate_idcard(this.state.idcard)
			&&this.validate_birthday(this.state.birthday)
			&&this.validate_password(this.state.password);
	}

	render() {
		return (
			<div className="content">
				<div className="content-item content-item--ipage">
					<div className="content-item__title">
						{trans('LINK_ID_CARD_NUMBER')}
					</div>
					<div className="content-item__main">
						<div className="content-item--ipage__main">
							<div className="content__sendinfo" id="J-sendinfo" style={{'padding-bottom':'5px'}}>
								{trans('input_real_info_hint')}
							</div>
							<div className="content__form">
								<form method="post" action="" id="J-validated-form" onSubmit={this.handleSubmit.bind(this)}>
									<div className="updateinfo-tip-wrap" style={{padding:0}}>
										<div className="updateinfo-tip">
											<span className="updateinfo-tip__b">{trans('Note:')} </span> {trans('cannot_change_real_info')}<br/>
										</div>
									</div>
									<div className="content__form-input">
										<input className="content__form-input-widget J-validated-field"
											placeholder={trans('Name')}
											maxLength="50"
											autoComplete="off"
											onChange={this.handleChangeName.bind(this)}>
										</input>
									</div>
									<ErrorMsg error_msg={this.state.realnameError}/>
									<div className="content__form-input">
										<input className="content__form-input-widget J-validated-field"
											placeholder={trans('ID_Card_Number')}
											maxLength="50"
											onChange={this.handleChangeIdcard.bind(this)}>
										</input>
									</div>
									<ErrorMsg error_msg={this.state.idcardError}/>
									{ this.props.need_birthday &&
									<div className="content__form-input birthday-input-group">
										<input className="content__form-input-widget J-validated-field"
											placeholder={trans('birthday')}
											maxLength="10"
											onChange={this.handleChangeBirthday.bind(this)}>
										</input>
									</div>
									}
									{ this.props.need_birthday &&
									<ErrorMsg error_msg={this.state.birthdayError}/>
									}
									<div className="content__form-input">
										<input type="password" className="content__form-input-widget J-validated-field"
											placeholder={trans('current_password_placeholder')}
											autoComplete="new-password"
											onChange={this.handleChangeCurrentPassword.bind(this)}>
										</input>
									</div>
									<Agreement/>
									<ErrorMsg error_msg={this.state.passwordError}/>
									<div className="content__submit-wrap">
										<input type="submit" className="content__submit" value={trans('SUBMIT')}></input>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		userInfo: state.data.userInfo,
		realinfo: state.realinfo,
		language: state.data.language,
		need_birthday: state.data.language && COUNTRY_NEED_REAL_INFO_BIRTHDAY.indexOf(state.data.language.country)>=0
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(Object.assign({}, realinfoActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SaveRealinfo);



// WEBPACK FOOTER //
// ./app/components/security/realinfo/SaveRealinfo.js